import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import NavLogo from '../NavLogo.png';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className="navbar navbar-expand-lg custom-navbar">
      {/* Logo Outside Container - Positioned Absolutely */}
      <Link className="navbar-brand-external d-flex align-items-center" to="/" onClick={closeMobileMenu}>
        <img 
          src={NavLogo} 
          alt="Sri Veda Gurukulam Logo" 
          className="navbar-logo-external"
        />
      </Link>

      <div className="container-fluid">
        {/* Mobile Toggle Button */}
        <button
          className={`mobile-toggle ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Desktop Navigation Menu */}
        <div className="collapse navbar-collapse desktop-nav-menu" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link className="nav-link active" to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about">About Us</Link>
            </li>
            <li className="nav-item dropdown">
              <a 
                className="nav-link" 
                href="#events"
                onClick={(e) => e.preventDefault()}
              >
                Events
                <span className="dropdown-arrow">▼</span>
              </a>
              <div className="dropdown-menu">
                <Link className="dropdown-item" to="/events">Current Events</Link>
                <Link className="dropdown-item" to="/previous-events">Previous Events</Link>
              </div>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/veda-gurukulam">Veda Gurukulam</Link>
            </li>
            <li className="nav-item dropdown">
              <a 
                className="nav-link" 
                href="#resources"
                onClick={(e) => e.preventDefault()}
              >
                Resources
                <span className="dropdown-arrow">▼</span>
              </a>
              <div className="dropdown-menu">
                <Link className="dropdown-item" to="/blog">Blog</Link>
                <a className="dropdown-item" href="#gallery">Gallery</a>
              </div>
            </li>
            <li className="nav-item">
              <Link className="nav-link contact-btn" to="/contact">Contact Us</Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Mobile Navigation */}
      <div className={`mobile-nav ${isMobileMenuOpen ? 'mobile-nav-open' : ''}`}>
        <ul className="mobile-nav-list">
          <li><Link to="/" onClick={closeMobileMenu}>Home</Link></li>
          <li><Link to="/about" onClick={closeMobileMenu}>About Us</Link></li>
          <li><Link to="/events" onClick={closeMobileMenu}>Current Events</Link></li>
          <li><Link to="/previous-events" onClick={closeMobileMenu}>Previous Events</Link></li>
          <li><Link to="/veda-gurukulam" onClick={closeMobileMenu}>Veda Gurukulam</Link></li>
          <li><Link to="/blog" onClick={closeMobileMenu}>Blog</Link></li>
          <li><a href="#gallery" onClick={closeMobileMenu}>Gallery</a></li>
          <li><Link to="/contact" className="mobile-contact-btn" onClick={closeMobileMenu}>Contact Us</Link></li>
        </ul>
      </div>

      {/* Mobile Overlay */}
      {isMobileMenuOpen && <div className="mobile-overlay" onClick={closeMobileMenu}></div>}
    </nav>
  );
};

export default Navbar;